module.exports = __webpack_public_path__ + "img/rz_logo.bdfa1dc6.svg";